module.exports = __webpack_public_path__ + "img/retailers.870542ac.svg";